<adapt-context-sidebar-implementation-kit [articleId]="ImplementationKitArticle.ManageAccess"
                                          context="page"></adapt-context-sidebar-implementation-kit>

<div adaptToolbarContent>
    <button adaptButtonIcon="add"
            data-test="add-access-level"
            (click)="addAccessLevel()">Add access level</button>
    <span class="dx-datagrid-export-button">
        <button adaptButtonIcon="dx-icon dx-icon-xlsxfile"
                adaptTooltip="Export all data"
                (click)="exportAllData!()"
                data-test="export-data-button"></button>
    </span>
    <button adaptButtonIcon="dx-icon dx-icon-revert"
            adaptTooltip="Reset columns"
            (click)="resetColumns!()"></button>
</div>

<dx-data-grid [columnAutoWidth]="true"
              [allowColumnResizing]="true"
              [allowColumnReordering]="true"
              [rowAlternationEnabled]="true"
              [hoverStateEnabled]="true"
              [showRowLines]="true"
              [showBorders]="true"
              [stateStoring]="dxGridWrapperHelper.stateStoringOptions"
              [dataSource]="gridData"
              (onInitialized)="onInitialized($event)">
    <dxo-data-grid-column-fixing [enabled]="true"> </dxo-data-grid-column-fixing>
    <dxo-data-grid-filter-row [visible]="true"> </dxo-data-grid-filter-row>
    <dxo-data-grid-load-panel [enabled]="true"> </dxo-data-grid-load-panel>
    <dxo-data-grid-header-filter [visible]="true"> </dxo-data-grid-header-filter>
    <dxo-data-grid-paging [pageSize]="25"> </dxo-data-grid-paging>
    <dxo-data-grid-pager [showPageSizeSelector]="true"
                         [allowedPageSizes]="[10, 25, 50, 100, 250]"> </dxo-data-grid-pager>
    <dxo-data-grid-scrolling> </dxo-data-grid-scrolling>

    <dxi-data-grid-sort-by-group-summary-info summaryItem="custom"></dxi-data-grid-sort-by-group-summary-info>
    <dxo-data-grid-summary [calculateCustomSummary]="calcCustomSummary">
        <dxi-data-grid-group-item summaryType="custom"
                                  name="roleTypeCustomSummary"
                                  showInColumn="Type"></dxi-data-grid-group-item>
    </dxo-data-grid-summary>

    <!-- Columns -->
    <dxi-data-grid-column caption="Type"
                          dataField="dummy_roleType"
                          [calculateGroupValue]="calculateRoleTypeDisplayValue"
                          groupCellTemplate="roleTypeCellTemplate"
                          dataType="string"
                          [groupIndex]="0"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="Access levels"
                          dataType="string"
                          dataField="role"
                          sortOrder="asc"
                          [allowSorting]="true"
                          [visible]="true"
                          cellTemplate="accessLevelCellTemplate"
                          [calculateCellValue]="calculateRoleCellValue"> </dxi-data-grid-column>

    <dxi-data-grid-column caption="People"
                          dataType="string"
                          dataField="people"
                          [allowSorting]="false"
                          [allowFiltering]="true"
                          [allowHeaderFiltering]="false"
                          [allowSearch]="true"
                          [visible]="true"
                          cellTemplate="peopleCellTemplate"> </dxi-data-grid-column>

    <dxi-data-grid-column caption=""
                          dataType="string"
                          dataField="actions"
                          cellTemplate="actionCellTemplate"
                          [allowSorting]="false"
                          [allowReordering]="false"
                          [allowHiding]="false"
                          [allowFiltering]="false"
                          [allowResizing]="false"
                          [fixed]="true"
                          fixedPosition="right"
                          [width]="50"> </dxi-data-grid-column>

    <!-- Templates -->
    <div *dxTemplate="let item of 'roleTypeCellTemplate'">
        User type: <b>{{ item.value }}</b>
    </div>
    <div *dxTemplate="let item of 'accessLevelCellTemplate'">
        <adapt-link-access-level [role]="item.data.role"></adapt-link-access-level>
    </div>

    <div *dxTemplate="let item of 'peopleCellTemplate'"
         class="d-flex flex-row align-items-center gap-1">
        @switch (item.data.people.length > 10) {
            @case (false) {
                @for (person of item.data.people; track person) {
                    <adapt-link-person [person]="person"
                                       [imageOnly]="true"></adapt-link-person>
                }
            }
            @case (true) {
                @for (person of item.data.people.slice(0, 10); track person) {
                    <adapt-link-person [person]="person"
                                       [imageOnly]="true"></adapt-link-person>
                }
                <a [routerLink]="managePeopleUrl"
                   [queryParams]="item.data.managePeopleParams"> +{{ item.data.people.length - 10 }} more users</a>
            }
        }
    </div>

    <div *dxTemplate="let item of 'actionCellTemplate'">
        <adapt-access-level-actions [role]="item.data.role"></adapt-access-level-actions>
    </div>
</dx-data-grid>
